import * as React from 'react';
import styled from 'styled-components';

import { fontWeights, grayScale } from '../inline-styles/variables';

interface Props {
  header: string;
  children: React.ReactNode;
}

const HEADER_HEIGHT: string = '72px';

const StSnapshot = styled.div`
  display: inline-block;
  width: 390px;
  height: 486px;
  box-sizing: border-box;
`;

const StSnapshotHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${HEADER_HEIGHT};
  padding: 0 32px;
  background-color: ${grayScale['9']};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 1.5rem;
  font-weight: ${fontWeights.bold};
  color: ${grayScale['3']};
  box-sizing: inherit;
`;

const StSnapshotBody = styled.div`
  min-height: calc(100% - ${HEADER_HEIGHT});
  padding: 32px;
  background-color: rgba(33, 37, 40, 0.6);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-sizing: inherit;
`;

class Snapshot extends React.Component<Props> {
  render() {
    const { header, children } = this.props;

    return (
      <StSnapshot>
        <StSnapshotHeader>{header}</StSnapshotHeader>
        <StSnapshotBody>{children}</StSnapshotBody>
      </StSnapshot>
    );
  }
}

export default Snapshot;



// WEBPACK FOOTER //
// ./src/app/ui/components/Snapshot.tsx